/** @jsxImportSource @emotion/react */
import { Divider } from "../../../../components/Divider";
import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import { MutateBusinessLineForm } from "../components/MutateBusinessLineForm";

export const NewBusinessLinePage = () => {
  return (
    <RouteFullScreenModal title="New business line">
      <Divider />
      <MutateBusinessLineForm />
    </RouteFullScreenModal>
  );
};
